import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlBarComponent } from 'src/app/components/controlbar/controlbar.component';
import { PainelComponent } from 'src/app/components/painel/painel.component';
import { CarrosselCabecalhoComponent } from 'src/app/components/carrossel-cabecalho/carrossel-cabecalho.component';
import { IEstadosDaPesquisa } from 'src/app/interfaces/iestados-pesquisa';
import { JwtService } from 'src/app/jwt.service';
import { ConfigService } from 'src/app/services/config.service';
import { SearchbarService } from 'src/app/services/searchbar.service';
import { FiltroLateralManager } from 'src/app/managers/filtro-manager';
import { AcessoAcaoManager } from 'src/app/managers/acesso-acao-manager';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BannerService } from 'src/app/services/banner.service';
import { Banner } from 'src/app/persistences/banner';

@Component({
  standalone: false,
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {

    @ViewChild(PainelComponent) painelComponent!: PainelComponent
    @ViewChild(ControlBarComponent) controlBarComponent!: ControlBarComponent;
    @ViewChild(CarrosselCabecalhoComponent) carrosselCabecalhoComponent?: CarrosselCabecalhoComponent;
    idsPesquisados: number[];
    isLoading: boolean;
    estadosDaPesquisa: IEstadosDaPesquisa;

    ocultaAbas: boolean;
    ordenacaoInput: string;
    isCliente: boolean;
    temAcesso = parseInt(localStorage.getItem('tem_acesso_business')) == 0 ? false : true;
    private subscription: Subscription;

    bannersHome: Banner[] = [];
    tempoSlideBanners: number = 5000;

    constructor(
        private jwtService: JwtService,
        private configService: ConfigService,
        private searchbarService: SearchbarService,
        private filtroLateralManager: FiltroLateralManager,
        private bannerService: BannerService,
        private acessoAcaoManager: AcessoAcaoManager,
        private router: Router
    ) {
        if(!this.temAcesso){
            this.router.navigateByUrl('/minha-conta/meus-pedidos');
        }
        this.isCliente = parseInt(localStorage.getItem('cd_usuario_business')) !== 0 ? false : true;
        this.jwtService.checkLogin();

        this.searchbarService.idsPesquisaEmitter.subscribe((res) => {
            this.onPesquisar(res);
        })
        this.searchbarService.ocultarAbasEmitter.subscribe((res) => {
            this.ocultarAbas(res);
        })
        this.searchbarService.isLoadingEmitter.subscribe((res) => {
            this.changeIsLoading(res);
        })
    }

    get ordenacaoDefault(): string {
        return this.configService.getConfig().getOrdenacaoDefault;
    }

    get exibeConsultaPainelLogin(): boolean {
        return this.configService.getConfig().getExibeConsultaPainelLogin;
    }

    ngOnInit() {
        this.ocultaAbas = true;
        this.idsPesquisados = [];
        this.estadosDaPesquisa = {
            estadoInicial: true,
            pesquisandoRegistros: false,
            registrosEncontrados: false,
            pesquisaPronta: false,
        }
        this.tempoSlideBanners = this.configService.getConfig().getTempoSlideBanner;
        this.carregarBannersHome();
    }

    ngOnDestroy() {
		this.subscription?.unsubscribe();
	}

    onPesquisar(ids: number[]) {
        this.idsPesquisados = ids;
    }

    getIdsConsultaPaineis(ids: number[]) {
        this.changeIsLoading(true);
        this.onPesquisar(ids);
        this.changeIsLoading(false);
    }

    changeIsLoading(bool: boolean) {
        this.estadosDaPesquisa.estadoInicial = false;
        this.estadosDaPesquisa.pesquisaPronta = !bool;
        this.estadosDaPesquisa.registrosEncontrados = this.idsPesquisados.length > 0;
        this.isLoading = bool;
    }

    ocultarAbas(ocultaAbas: boolean) {
        this.ocultaAbas = ocultaAbas;
    }

    setOrdemPainel(ordem: string) {
        this.painelComponent.orderByComListaItens(ordem);
    }

    setAbrirFiltroPainel(bool: boolean) {
        this.painelComponent.setStatusFiltro(bool);
        this.filtroLateralManager.setIsFiltroAberto(bool);
    }

    setOrdenacaoInput(ordenacao: string) {
        this.ordenacaoInput = ordenacao;
    }

    onBannerClicado(cdAcesso: string): void {
        this.acessoAcaoManager.getIdsConsultaAcessoAcao(cdAcesso).then((ids) => {
            this.changeIsLoading(true);
            this.onPesquisar(ids);
            this.changeIsLoading(false);
        });
    }

    private carregarBannersHome(): void {
        this.bannerService.getAtivosPorFilial().subscribe({
            next: (banners) => {
                this.bannersHome = banners ?? [];
                if (this.bannersHome.length === 0 && !this.configService.getConfig().getExibeConsultaPainelLogin) {
                    this.carrosselCabecalhoComponent?.executarPrimeiraConsulta();
                }
            },
            error: () => {
                this.bannersHome = [];
            }
        });
    }
}
